<div class="bg-enrollment m-0 overflow-auto">
  <header>
    <div class="clearfix header-enrollment">
      <div class="container">
        <div class="logo-enrollment float-start my-3"></div>
        <!-- Contenedor del Dropdown -->
        <div class="dropdown float-end d-flex">
          <div class="text-muted py-4 pe-3">{{"DCO.enrollment_process" | translate}}</div>
          <button class="btn btn-link text-dark fw-semibold small dropdown-toggle d-flex align-items-center"
            type="button" (click)="menuAbierto = !menuAbierto; $event.stopPropagation()">
            <i class="fas fa-user-circle me-2 fa-2x"></i>
            {{ username ? username : ('Login' | translate) }}
          </button>
          <!-- Menú con clase dinámica 'show' de Bootstrap -->
          <ul class="dropdown-menu dropdown-menu-end shadow border-0" [class.show]="menuAbierto"
            style="right: 0; left: auto; background-color: white;">

            <!-- Selector de Idioma -->
            <li class="px-3 py-2" (click)="$event.stopPropagation()">
              <div class="d-flex align-items-center" style="min-width: 150px;">
                <i class="fas fa-globe me-2 text-muted"></i>
                <select class="form-select form-select-sm border-1" [(ngModel)]="selectedLanguage"
                  (change)="SetLanguage(selectedLanguage); menuAbierto = false">
                  <option *ngFor="let language of languages" [value]="language">
                    {{ language }}
                  </option>
                </select>
              </div>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <!-- Opción de Logout / Login -->
            <li *ngIf="username; else loginLink">
              <button class="dropdown-item text-danger d-flex align-items-center"
                (click)="logOut(); menuAbierto = false">
                <i class="fas fa-sign-out-alt me-2"></i> {{"DCO.Title_SignOut" | translate}}
              </button>
            </li>
            <ng-template #loginLink>
              <li>
                <a class="dropdown-item d-flex align-items-center" routerLink="/login" (click)="menuAbierto = false">
                  <i class="fas fa-sign-in-alt me-2"></i> Login
                </a>
              </li>
            </ng-template>
          </ul>
        </div>
      </div>
    </div>
  </header>
  <div class="container">
    <div class="d-flex w-50 my-4 mx-auto">
      <div class="d-flex flex-fill">
        <div class="d-flex flex-column">
          <div class="rounded-circle bg-primary p-2 text-white fw-semibold text-center mx-auto"
            style="width: 40px; height: 40px;"><i class="fa-solid fa-check text-white"></i></div>
          <span class="text-sm mt-2 text-nowrap">{{"DCO.Enrollment_FillInData" |
            translate}}<!--Completar datos--></span>
        </div>
        <div class="mx-4 border-bottom border-4 border-primary w-100 mb-4"></div>
      </div>
      <div class="d-flex flex-fill">
        <div class="d-flex flex-column my-auto">
          <div class="rounded-circle bg-primary p-2 text-white fw-semibold text-center mx-auto"
            style="width: 40px; height: 40px;"><i class="fa-solid fa-check text-white"></i></div>
          <span class="text-sm mt-2 text-nowrap">{{"DCO.Enrollment_Documents" | translate}}<!--Documentos--></span>
        </div>
        <div class="mx-4 border-bottom border-4 border-primary w-100 mb-4"></div>
      </div>
      <div class="d-flex flex-fill">
        <div class="d-flex flex-column my-auto">
          <div class="rounded-circle bg-primary p-2 text-white fw-semibold text-center mx-auto"
            style="width: 40px; height: 40px;">3</div>
          <span class="text-sm mt-2 text-nowrap text-muted">{{"DCO.Enrollment_Finish" |
            translate}}<!--Finalizar--></span>
        </div>
      </div>
    </div>
    <div class="row mt-1 mb-5">
      <div class="col-md-6 my-auto">
        <h5 class="fw-semibold text-primary">{{ "DCO.EndEnrollment_Question" | translate }}<!--¿Esta es tu primera
          disputa?--></h5>
        <p class="mt-4 text-md">{{ "DCO.EndEnrollment_Answer_p1" | translate }}<!--Las disputas se producen cuando
          uno de tus clientes cuestiona un pago (una de las ventas hechas en tu negocio) con su banco. No te
          preocupes por enfrentar una disputa, es parte del proceso de cobro con las tarjetas de crédito o débito.-->
        </p>
        <p class="text-md">{{ "DCO.EndEnrollment_Answer_p2" | translate }}
          <!--Estamos aquí para ayudarte a gestionar esas disputas y a defenderlas.-->
        </p>
      </div>
      <div class="col-md-6 d-flex flex-column align-items-center justify-content-center">
        <div [innerHTML]="htmlMessage" (click)="VerVideo($event)" class="mt-3 text-center"></div>
      </div>
    </div>
    <div class="row">
      <div class="d-flex justify-content-center">
        <div class="mx-1 my-3">
          <button class="btn btn-outline-primary w-100" (click)="GoBack()">
            {{ "DCO.Enrollment_GoBack" | translate }}
          </button>
        </div>
        <div *ngIf="!showInfoEnrollment" class="mx-1 my-3">
          <button class="btn btn-primary w-100" (click)="GoDisputes()">
            {{ "DCO.Enrollment_StartsManage" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>